import moment from "moment";
import "./loyaltyShortlink.scss";
import pluralize from "pluralize";
import RewardList from "../../../../../../Public/Shortlink/components/RewardList";
import LockedLoyaltyCard from "../../../../../../Public/Shortlink/components/LockedLoyaltyCard";
import ShortlinkStoreDetails from "../../../../../../Public/Shortlink/components/ShortlinkStoreDetails";
import AllStoreBottomStickyMenu from "../../../../../../Public/Shortlink/components/AllStoreBottomStickyMenu";

const LoyaltyShortlinkPage = ({
  data,
  entityId,
  currencyView,
  allStoresArr,
}) => {
  const loyaltyData = data?.loyalty;
  const customerData = data?.customer;
  const custRewards = data?.customer_rewards?.filter(
    (reward) =>
      (reward.is_active && reward.reward_type === "campaign") || // for campaign and auto-campaign rewards
      reward?.redemption?.applicable_stores || // for QR reward
      reward?.new_customer_referral_reward || // for b2c new customer reward
      reward?.existing_customer_referral_reward // for b2c existing customer reward
  );
  const pointsBranding = loyaltyData?.settings?.points_branding;

  const getExpiryText = (last_transaction_date, points_expiry) => {
    if (points_expiry?.active && last_transaction_date) {
      const expiryDate = moment(last_transaction_date).add(
        points_expiry.current,
        "months"
      ); // last_transaction_date + add months

      const duration = moment.duration(expiryDate.diff(moment()));
      const expiresInMonths = duration.months();
      const expiresInDays = duration.days();
      const expiresOnText = `on ${expiryDate.format("MMM DD, YYYY")}`;

      return expiresInMonths > 0 || (expiresInMonths === 0 && expiresInDays > 7)
        ? `(Expires ${expiresOnText})`
        : expiresInDays === 0
        ? `(Expires today)`
        : expiresInDays > 0
        ? `(Expires in ${expiresInDays} ${pluralize("days", expiresInDays)})`
        : "";
    }

    return "";
  };

  return (
    <div className="fb-and-loyalty-shortlink-root">
      <div
        className="welcome-user-banner"
        style={{
          color: loyaltyData?.colors?.text || "white",
          backgroundColor: loyaltyData?.colors?.theme,
        }}
      >
        <div className="center-container">
          <h3>Hello {customerData?.name}</h3>
          {data?.customer_points?.current_points > 0 && (
            <p>
              You have{" "}
              <b>
                {!pointsBranding?.active && loyaltyData?.type === "cashback"
                  ? currencyView
                  : ""}
                {data?.customer_points?.current_points}{" "}
                {loyaltyData?.type === "cashback"
                  ? pointsBranding?.active
                    ? pluralize(
                        pointsBranding?.name,
                        data?.customer_points?.current_points
                      )
                    : "Cash"
                  : pluralize(
                      pointsBranding?.active ? pointsBranding?.name : "point",
                      data?.customer_points?.current_points
                    )}
              </b>{" "}
              {getExpiryText(
                data?.customer_points?.exception_date,
                loyaltyData?.settings?.points_expiry
              )}
            </p>
          )}
        </div>
      </div>
      <div className="fb-and-loyalty-shortlink">
        <ShortlinkStoreDetails
          loyaltyData={loyaltyData}
          storeName={data?.entity_details?.name}
        />

        <RewardList
          rewards={
            custRewards?.length > 0
              ? custRewards?.sort((a, b) =>
                  moment(a?.expires_at).diff(moment(b?.expires_at))
                )
              : []
          }
          currencyView={currencyView}
        />

        {loyaltyData?.is_active && (
          <>
            <LockedLoyaltyCard
              loyaltyData={loyaltyData}
              currencyView={currencyView}
              storeName={data?.entity_details?.name}
              pointsObj={{
                order_value: data?.order_value,
                lifetime_spent: data?.lifetime_spent,
                current_points: data?.customer_points?.current_points ?? 0,
              }}
            />
            <div className="how-to-redeem">
              <h3>How to Redeem?</h3>
              <p>
                Give your mobile number to the staff on your next purchase and
                ask them to redeem.
              </p>
            </div>
          </>
        )}
      </div>

      {allStoresArr?.length > 1 && (
        <AllStoreBottomStickyMenu
          activeStores={allStoresArr?.filter(
            (store) =>
              (store?._id || store?.id) !== entityId && store?.is_active
          )}
        />
      )}
    </div>
  );
};

export default LoyaltyShortlinkPage;
